import { render, staticRenderFns } from "./CBtn.vue?vue&type=template&id=d1f8afc4&scoped=true"
import script from "./CBtn.vue?vue&type=script&lang=js"
export * from "./CBtn.vue?vue&type=script&lang=js"
import style0 from "./CBtn.vue?vue&type=style&index=0&id=d1f8afc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f8afc4",
  null
  
)

export default component.exports